import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import { useState } from "react";
import Button from "../atoms/Button";
import ServerErrorMessage from "../atoms/ServerErrorMessage";

export interface AttendanceData {
    totalAttendees: number;
    totalStudentAttendees: number;
}

interface Props {
    onSubmit?: (attendanceData: AttendanceData) => Promise<void>;
    attendanceData?: AttendanceData;
}

const ManualAttendanceEntryForm = ({ onSubmit, attendanceData }: Props) => {
    const [pending, setPending] = useState<boolean>();
    const [error, setError] = useState<string>();

    const handleSuccess = async (values: any) => {
        try {
            const totalStudentAttendees = Number.parseInt(
                values.totalStudentAttendees,
                10
            );
            const totalAttendees = Number.parseInt(values.totalAttendees, 10);
            if (totalStudentAttendees == null || totalAttendees == null) {
                throw new Error("value unexpectedly null");
            }
            const pendingSubmission = onSubmit?.({
                totalStudentAttendees,
                totalAttendees,
            });
            if (pendingSubmission != null) {
                setPending(true);
                await pendingSubmission;
            }
        } catch (e) {
            setError("An error occured while handling submission");
            console.error("An error occured while handling submission", e);
        } finally {
            setPending(false);
        }
    };

    if (attendanceData != null) {
        const { totalAttendees, totalStudentAttendees } = attendanceData;
        return (
            <div className="manual-attendance-entry-form manual-attendance-entry-form--completed">
                <div className="manual-attendance-entry-form__title manual-attendance-entry-form__title--completed">
                    No. of attendees
                </div>
                <div>
                    {totalAttendees} total attendees, {totalStudentAttendees}{" "}
                    UTS students
                </div>
            </div>
        );
    }

    return (
        <div className="manual-attendance-entry-form">
            <div className="manual-attendance-entry-form__title">
                How many people attended this event?
            </div>
            <div className="manual-attendance-entry-form__description">
                No one has checked into this past event. Please report how many
                people attended the event.
            </div>
            <div>
                <ReactForm
                    className="manual-attendance-entry-form__form"
                    onSuccess={handleSuccess}
                >
                    <ReactFormField
                        type="text"
                        name="totalAttendees"
                        label="Total no. of attendees"
                        required={true}
                        validators={["digits"]}
                        disabled={pending}
                    />
                    <ReactFormField
                        type="text"
                        name="totalStudentAttendees"
                        label="No. of UTS students"
                        required={true}
                        validators={["digits", "<=field:totalAttendees"]}
                        disabled={pending}
                    />
                    <Button type="submit" styles={["green"]} loading={pending}>
                        Submit
                    </Button>
                </ReactForm>
                <ServerErrorMessage>{error}</ServerErrorMessage>
            </div>
        </div>
    );
};

export default ManualAttendanceEntryForm;
